<template>
  <svg
    :width="size"
    :height="size * 1.5"
    :viewBox="`0 0 ${size} ${size * 1.5}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :d="
        `M${(1.5 / 8) * size} ${(11 / 8) * size}L${(6.5 / 8) * size} ${(6 / 8) *
          size}L${(1.5 / 8) * size} ${(1 / 8) * size}`
      "
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 8,
    },
  },
}
</script>

<style lang="scss">
.arrow {
  position: relative;
  bottom: 3px;
  margin: auto 10px;
  cursor: pointer;
  &_left {
    transform: rotate(180deg);
  }
  &_color {
    &_timeint,
    &_article {
      stroke: $title-color;
    }
    &_selected {
      stroke: $primary-color2;
    }
    &_contrast {
      stroke: white;
    }
  }
  &_week {
    margin-top: 6px;
    margin-right: 1px;
  }

  &.no-bottom {
    bottom: 0;
  }
}

#app[data-theme='dark'] {
  .arrow {
    &_color {
      &_timeint,
      &_article {
        stroke: #fff;
      }
    }
  }
}
</style>
